<form [formGroup]="segmentCreationForm" class="form inline">
  <div class="row">
    <div class="col-2">
      <nb-card>
        <nb-card-body>
          <select
            placeholder="Catégorie"
            [formControlName]="'metaCategory'"
            class="form-select"
            style="width: 100%; cursor: pointer"
            >
            @for (meta of metaCategories; track meta) {
              <option value="{{ meta.id }}">{{ meta.label }}</option>
            }
          </select>
        </nb-card-body>
      </nb-card>
    </div>
    <div class="col-5"></div>

  </div>

  <div class="row">
    <div class="col-12">
      <nb-card [nbSpinner]="metaCategoryChanges" nbSpinnerStatus="primary">
        <nb-card-header>
          @if (view === 'table') {
            <input
              type="text"
              placeholder="Rechercher"
              class="form-control search-field"
              name="search"
              [formControlName]="'search'"
              />
          }
        </nb-card-header>
        <nb-card-body>

          @if (view === 'table') {
            <app-table
              [showTableControls]="false"
              [metaCategory]="metaCategory"
              [currentCategory]="currentCategory"
              [dicoEntries]="filteredDicoEntries"
              [segments]="segments"
              [stockOrDispo]="stockOrDispo"
              [numberOfDays]="numberOfDays"
              [forecastDates]="forecastDates"
              [searchString]="searchString"
              (onRowClicked)="setCategory($event)"
            ></app-table>
          }
        </nb-card-body>
      </nb-card>
    </div>
  </div>

  @if (currentCategory) {
    <div class="row">
      <div class="col-5">
        <nb-card style="min-height: 350px" [nbSpinner]="!displayForms" nbSpinnerStatus="primary">
          <nb-card-header> Courbe de lift pour la catégorie {{ currentCategory.label }} </nb-card-header>
          <nb-card-body>
            @if (displayForms) {
              <canvas
                baseChart
                [data]="liftCurveData"
                [options]="liftCurveChartOptions"
                type="line"
                [legend]="false"
                id="lift-curve-chart"
                >
              </canvas>
            }
          </nb-card-body>
        </nb-card>
        <nb-card>
          <nb-card-body>
            <label for="volume">Volume</label>
            <input
              type="range"
              [disabled]="!displayForms"
              class="custom-range"
              name="volume"
              min="1"
              max="100"
              [formControlName]="'volume'"
              (change)="onVolumeChange($event)"
              />
            </nb-card-body>
          </nb-card>
        </div>
        <div class="col-2">
          <nb-card [nbSpinner]="!displayForms" nbSpinnerStatus="primary" style="min-height: 250px">
            <nb-card-body>
              @if (displayForms) {
                <nb-alert class="status-success text-center mb-1">
                  <strong>{{ emailsRatio | number: '.0-0' }}</strong>
                  <span><small>Nombre d'emails que vous pouvez cibler</small></span>
                </nb-alert>
                <nb-alert class="status-success text-center mb-1">
                  <strong>{{ volume | number: '.0-0' }} %</strong>
                  <span><small>du total de la base d'email sera ciblé</small></span>
                </nb-alert>
                <nb-alert class="status-success text-center mb-1">
                  <strong>{{ potential | number: '.0-0' }} %</strong>
                  <span><small>du potentiel de ventes atteint</small></span>
                </nb-alert>
                <nb-alert class="status-success text-center mb-0">
                  <strong>x {{ lift | number: '.1-1' }}</strong>
                  <span><small>Lift</small></span>
                </nb-alert>
                <!-- Add the Venn diagram button/popover here -->
                <div class="venn-button-container">
                  <!-- Bouton désactivé sans popover -->
                  @if (segments.length === 0) {
                    <button
                      nbButton fullWidth status="info"
                      class="mt-3"
                      disabled>
                      Diagramme de Venn
                    </button>
                  }
                  <!-- Bouton actif avec popover -->
                  @if (segments.length > 0) {
                    <button
                      nbButton fullWidth status="info"
                      [nbPopover]="vennDiagramTemplate"
                      nbPopoverTrigger="hover"
                      nbPopoverPlacement="left"
                      class="mt-3">
                      Diagramme de Venn
                    </button>
                  }
                </div>
              }
            </nb-card-body>
          </nb-card>
        </div>
        <div class="col-5">
          <!-- suppression du graph de prévision
          <nb-card style="min-height: 350px" [nbSpinner]="!displayForms" nbSpinnerStatus="primary">
            <nb-card-header>Prévisions de vente pour la catégorie {{ currentCategory.label }}</nb-card-header>
            <nb-card-body>
              <canvas
                *ngIf="displayForms"
                baseChart
                [data]="evolData"
                [options]="evolCurveChartOptions"
                type="line"
                [legend]="true"
                id="evol-curve-chart"
                >
              </canvas>
            </nb-card-body>
          </nb-card>-->
          <nb-card>
            <nb-card-body>
              <div class="row">
                <div class="col-4">
                  <select [formControlName]="'capping'" (change)="onValueChange($event)" class="form-control">
                    @for (cap of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track cap) {
                      <option [value]="cap">{{ cap }}</option>
                    }
                  </select>
                </div>
                <div class="col-8">
                  <label>
                    {{ selectedCap | i18nPlural: {'=1': 'message', 'other': 'messages'} }}
                    maximum par utilisateur
                  </label>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
          <nb-card>
            <nb-card-body>
              <div class="row">
                <div class="col-5">
                  <p class="mt-2"><b>Catégorie</b> {{ currentCategory.label }}</p>
                </div>
                <div class="col-5">
                  <button
                [disabled]="
                  !displayForms || !canUpsertSegment || buildingCampaign || mergingCampaign || segmentsGenerating
                "
                    nbButton
                    appearance="filled"
                    status="danger"
                    (click)="upsertSegment()"
                    [nbSpinner]="buildingCampaign"
                    nbSpinnerStatus="danger"
                    class="btn btn-primary"
                    >
                    @if (!selectedSegment) {
                      Ajouter le segment
                    }
                    @if (selectedSegment) {
                      Mettre à jour le segment
                    }
                  </button>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
          <nb-card [nbSpinner]="buildingCampaign || mergingCampaign" nbSpinnerStatus="primary" style="min-height: 200px">
            <nb-card-header>Campagne</nb-card-header>
            <nb-card-body>
              @if (segments.length > 0) {
                <table class="table table-segments">
                  <thead>
                    <tr>
                      <th scope="col" class="text-center">
                        <nb-checkbox
                          status="danger"
                          [disabled]="segments.length < 2"
                          [checked]="allSegmentChecked"
                          (checkedChange)="checkAllSegment($event)"
                        ></nb-checkbox>
                      </th>
                      <th>Catégories</th>
                      <th>Volume</th>
                      <th>Lift</th>
                      <th>Potentiel</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (segment of segments; track segment; let index = $index) {
                      <tr
                        [class.active]="segment === selectedSegment"
                        [class.selectable]="segment.categories.length === 1"
                        campaignSegmentEditor
                        [segment]="segment"
                        [disabledCheck]="segments.length < 2"
                        (onClick)="selectSegment(segment)"
                        (onCheck)="checkSegment(segment, $event)"
                        (onDelete)="deleteSegment(segment)"
                      ></tr>
                    }
                  </tbody>
                  <tfoot>
                    <tr>
                      <th>TOTAL</th>
                      <td></td>
                      <td class="number">{{ total | number: '.0-0' }}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              }
            </nb-card-body>
          </nb-card>
          <nb-card class="segments-actions">
            <nb-card-body>
              <div class="row actions g-2">
                <div class="col-auto">
                  <button nbButton appearance="outline" status="danger"
                          (click)="onClickMergeCampaigns()"
                          [disabled]="!canMergeCampaigns || buildingCampaign || mergingCampaign || segmentsGenerating"
                          [nbSpinner]="mergingCampaign" nbSpinnerStatus="danger">
                    Fusionner les campagnes
                  </button>
                </div>

                <div class="col-auto">
                  <button nbButton appearance="filled" status="danger"
                          (click)="askGenerateSegments()"
                          [disabled]="segments.length === 0 || buildingCampaign || mergingCampaign || segmentsGenerating"
                          [nbSpinner]="segmentsGenerating" nbSpinnerStatus="danger">
                    Générer les segments
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  @if (segmentsGenerating) {
                    <span style="color: #35a2eb"
                      >Segments en cours de création, cela peut prendre plusieurs minutes</span
                      >
                  }
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
        @if (displayInfosCRM) {
          <div class="row mt-4 full-width">
            <div class="col-lg-5 col-md-12">
              <nb-card style="min-height: 350px" [nbSpinner]="spinnerInfosCRM" nbSpinnerStatus="primary">
                <nb-card-header>Répartition par Genre pour {{ currentCategory.label }}</nb-card-header>
                <nb-card-body>
                  <canvas
                    baseChart
                    [data]="genreRealiteChartData"
                    [options]="genreRealiteChartOptions"
                    [plugins]="genreChartPlugins"
                    type="bar"
                    [legend]="false"
                    id="genre-distribution-chart"
                    >
                  </canvas>
                </nb-card-body>
                <nb-card-body>
                  <canvas
                    baseChart
                    [data]="genreSegmentChartData"
                    [options]="genreSegmentChartOptions"
                    [plugins]="genreChartPlugins"
                    type="bar"
                    [legend]="false"
                    id="genre-distribution-chart"
                    >
                  </canvas>
                </nb-card-body>
              </nb-card>
            </div>
            <!-- Segment Charts container -->
            <div class="col-lg-7 col-md-12">
              <div class="row">
                <!-- Segment Achats Chart -->
                <div class="col-md-6 mb-3">
                  <nb-card style="min-height: 350px" [nbSpinner]="spinnerInfosCRM" nbSpinnerStatus="primary">
                    <nb-card-header>Type d'acheteurs pour le segment {{ currentCategory.label }}</nb-card-header>
                    <nb-card-body>
                      <div class="chart-container">
                        <canvas baseChart
                          [data]="pieChartDataSegmentAchat"
                          [options]="pieChartOptionsSegmentAchat"
                          [type]="'pie'">
                        </canvas>
                      </div>
                    </nb-card-body>
                  </nb-card>
                </div>
                <!-- Segment Email Chart -->
                <div class="col-md-6 mb-3">
                  <nb-card style="min-height: 350px" [nbSpinner]="spinnerInfosCRM" nbSpinnerStatus="primary">
                    <nb-card-header>Engagement email - {{ currentCategory.label }}</nb-card-header>
                    <nb-card-body>
                      <div class="chart-container">
                        <canvas baseChart
                          [data]="pieChartDataSegmentEmail"
                          [options]="pieChartOptionsSegmentEmail"
                          [type]="'pie'">
                        </canvas>
                      </div>
                    </nb-card-body>
                  </nb-card>
                </div>
              </div>
            </div>
          </div>
        }
        @if (displayInfosCRM) {
          <div class="row mt-4 full-width">
            <!-- Regions Map Chart - Larger -->
            @if (regionsMapData.length > 0) {
              <div class="col-lg-6 col-md-12">
                <nb-card style="min-height: 500px" [nbSpinner]="spinnerInfosCRM" nbSpinnerStatus="primary">
                  <nb-card-header>Répartition des utilisateurs par région pour le segment {{ currentCategory.label }}</nb-card-header>
                  <nb-card-body>
                    <div id="regions-map-container" class="chart-container"></div>
                  </nb-card-body>
                </nb-card>
              </div>
            }
            <div class="col-lg-6 col-md-12">
              <nb-card style="min-height: 300px" [nbSpinner]="spinnerInfosCRM" nbSpinnerStatus="primary">
                <nb-card-header>Pyramide des Âges pour le segment {{ currentCategory.label }}</nb-card-header>
                <nb-card-body class="age-pyramid-container">
                  <div class="chart-container">
                    <canvas baseChart
                      [data]="agePyramidData"
                      [options]="agePyramidOptions"
                      [type]="'bar'">
                    </canvas>
                  </div>
                </nb-card-body>
              </nb-card>
            </div>
          </div>
        }
      </div>
    }
  </form>



  <ng-template #dialog let-data let-ref="dialogRef">
    <nb-card>
      <nb-card-body>Êtes-vous sûr de vouloir générer les segments ?</nb-card-body>
      <nb-card-footer>
        <div class="row">
          <div class="col text-center">
            <button nbButton status="success" (click)="generateSegments()">Oui</button>
          </div>
          <div class="col text-center">
            <button nbButton status="danger" (click)="ref.close()">Non</button>
          </div>
        </div>
      </nb-card-footer>
    </nb-card>
  </ng-template>

  <ng-template #dialogError let-data let-ref="dialogRef">
    <nb-card>
      <nb-card-body>Erreur de génération des segments</nb-card-body>
      <nb-card-footer>
        <div class="row">
          <div class="col text-center">
            <button nbButton status="danger" (click)="ref.close()">Ok</button>
          </div>
        </div>
      </nb-card-footer>
    </nb-card>
  </ng-template>

  <ng-template #dialogOk let-data let-ref="dialogRef">
    <nb-card>
      <nb-card-body>Les segments ont été générés</nb-card-body>
      <nb-card-footer>
        <div class="row">
          <div class="col text-center">
            <button nbButton status="success" (click)="ref.close()">Ok</button>
          </div>
        </div>
      </nb-card-footer>
    </nb-card>
  </ng-template>

  <ng-template #dialogCurveError let-data let-ref="dialogRef">
    <nb-card>
      <nb-card-body>{{ errorMessage }}</nb-card-body>
      <nb-card-footer>
        <div class="row">
          <div class="col text-center">
            <button nbButton status="danger" (click)="ref.close()">Ok</button>
          </div>
        </div>
      </nb-card-footer>
    </nb-card>
  </ng-template>

  <ng-template #vennDiagramTemplate>
    <div class="venn-diagram-popover">
      <h5>Diagramme de Venn</h5>
      @if (!vennDiagrammGenerating) {
        <div>
          <venn-diagramm [data]="vennData"></venn-diagramm>
        </div>
      }
      @if (vennDiagrammGenerating) {
        <div>
          <nb-spinner status="primary"></nb-spinner>
        </div>
      }
    </div>
  </ng-template>